/* 司馬懿傳・第 2 章：五丈原・對壘百餘日（青龍二年，234）
 * 史實：《晉書·宣帝紀》「亮又率眾十餘萬出斜谷，壘于郿之渭水南原。……諸將欲住渭北以待之，帝曰：『百姓積聚皆在渭南，此必爭之地也。』
 *       遂引軍而濟，背水為壘。」「時朝廷以亮僑軍遠寇，利在急戰，每命帝持重，以候其變。亮數挑戰，帝不出，因遺帝巾幗婦人之飾。
 *       帝怒，表請決戰，天子不許，乃遣骨鯁臣衞尉辛毗杖節為軍師以制之。後亮復來挑戰，帝將出兵以應之，毗杖節立軍門，帝乃止。」
 *       「與之對壘百餘日，會亮病卒，諸將燒營遁走，百姓奔告，帝出兵追之。亮長史楊儀反旗鳴鼓，若將距帝者。帝以窮寇不之逼，
 *       於是楊儀結陣而去。經日，乃行其營壘，觀其遺事，獲其圖書、糧穀甚眾。帝審其必死，曰：『天下奇才也。』」
 *       「先是，亮使至，帝問曰：『諸葛公起居何如，食可幾米？』對曰：『三四升。』次問政事，曰：『二十罰已上皆自省覽。』」
 *       《三國志·郭淮傳》「淮策亮必爭北原，宜先據之……淮遂屯北原。塹壘未成，蜀兵大至，淮逆擊之。」
 *       《諸葛亮傳》注引《漢晉春秋》：姜維令儀反旗鳴鼓，宣王乃退；「死諸葛走生仲達」「吾能料生，不便料死也」。
 * 流程（「等」）：渡渭水，背水為壘 → 郭淮據北原，擊退來爭的蜀兵 → 對壘百餘日：天數往前走，蜀軍不時到營門挑戰、
 *       送來巾幗，營中的怒氣一路上升；司馬懿不能出營，只能回帥帳「表請決戰」示武於眾（怒氣下降），之後辛毗杖節立軍門；
 *       亮使來了，去問他諸葛公的寢食 → 長星墜亮之壘，亮卒：追擊，楊儀反旗鳴鼓，窮寇勿逼 → 行其營壘：天下奇才也。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, vanish, rout } from '../kit.ts';
import { TR, walkTo, flag } from './simayi_kit.ts';
import { CAMP, CAMP_R, GATE, NORTH, BEIYUAN, YUAN, RAMP, VALLEY } from '../maps/simayi_wuzhang.ts';

const LV = 14, DAY = 1.1, DAYS = 104, ANGER_MAX = 100;
const SHU = { spec: TR.shu, name: '蜀兵', hp: 620, maxHp: 620, atk: 30 };
const TENT = [CAMP[0] + 120, CAMP[1] - 120], TAUNT = [GATE[0] - 520, GATE[1]];
const SPOILS = [[YUAN[0], YUAN[1] - 60, '營壘'], [YUAN[0] - 300, YUAN[1] + 160, '圖書'], [YUAN[0] + 300, YUAN[1] + 160, '糧穀']];
const inCamp = (u) => SG.gd(u.x, u.y, CAMP[0], CAMP[1]) < CAMP_R + 120;

export default {
  id: 'simayi-2', map: 'simayi_wuzhang', hero: 'simayi',
  title: '第 2 章　五丈原・對壘百餘日', year: '青龍二年（234）',
  brief: {
    quote: [{ text: '亮數挑戰，帝不出，因遺帝巾幗婦人之飾。', src: '《晉書·宣帝紀》' }, { text: '亮志大而不見機，多謀而少決，好兵而無權，雖提卒十萬，已墮吾畫中，破之必矣。', src: '司馬懿與弟孚書，《晉書·宣帝紀》' }],
    text: '諸葛亮第五次北伐，率十餘萬人出斜谷，屯在五丈原，分兵屯田，打算久住。蜀軍遠來，利在急戰；朝廷一再命令司馬懿持重，等它生變。這一章不是比誰打得多，是比誰等得住。',
    goals: ['渡渭水，背水為壘', '郭淮據北原', '對壘百餘日：不出營、壓住營中的怒氣', '亮卒：追擊，但窮寇勿逼', '行其營壘'],
  },
  words: { ally: '魏軍', foe: '蜀兵' },
  stars: [
    { text: '對壘期間一步都沒出營', ok: (m) => !m.vars.sortie },
    { text: '問了亮使諸葛公的寢食', ok: (m) => !!m.vars.asked },
    { text: '楊儀反旗之後沒有逼近', ok: (m) => !m.vars.pressed },
  ],
  steps: [
    { // 0. 渡渭水，背水為壘
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = NORTH[0]; me.y = NORTH[1] + 100;
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x - 100 + (i % 4) * 50, me.y + 90 + Math.floor(i / 4) * 60, '魏兵'); u.spec = TR.wei; u.hp = u.maxHp = 700; u.atk = 28; m.join(u, me); return u; });
        V.gh = ally(w, 'guohuai', me.x + 90, me.y + 40, LV);
        m.line('魏將', '蜀軍勢大，不如住在渭北等他們來。');
        m.after(3, () => m.line('司馬懿', '百姓積聚皆在渭南，此必爭之地也。渡河！'));
        m.mark('camp', CAMP[0], CAMP[1], '立營');
        m.obj('camp', '渡渭水，在南岸立營（背水為壘）');
      },
      tick(m, w) {
        m.chanAt(w.player, 'camp', CAMP[0], CAMP[1], 180, 2, '立營', () => { m.vars.camped = true; });
        return !!m.vars.camped;
      },
    },
    { // 1. 郭淮據北原
      enter(m, w) {
        const V = m.vars;
        m.done('camp'); m.unmark('camp');
        m.card('遂引軍而濟，背水為壘。', '《晉書·宣帝紀》');
        m.after(3, () => m.line('郭淮', '亮必爭北原，宜先據之。若亮跨渭登原，連兵北山，隔絕隴道，此非國之利也。'));
        m.after(7, () => {
          m.line('司馬懿', '善。伯濟去北原。');
          V.gh.hold = BEIYUAN.slice();
          m.mark('by', BEIYUAN[0], BEIYUAN[1], '北原');
          m.obj('by', '郭淮據北原：擊退來爭的蜀兵');
          m.after(9, () => {
            m.big('蜀兵大至！');
            m.card('塹壘未成，蜀兵大至，淮逆擊之。', '《三國志·郭淮傳》');
            V.wave = Array.from({ length: 8 }, (_, i) => { const u = m.foe('huangjin', BEIYUAN[0] - 1200 - (i % 4) * 70, BEIYUAN[1] + 300 + Math.floor(i / 4) * 90, SHU); u.home = BEIYUAN.slice(); return u; });
          });
        });
      },
      tick(m, w) {
        const V = m.vars;
        if (!V.wave) return false;
        m.prog('by', V.wave.filter((u) => !u.alive).length);
        return V.wave.every((u) => !u.alive);
      },
    },
    { // 2. 對壘百餘日
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('by'); m.unmark('by');
        V.t0 = w.t; V.anger = 0; V.nextTaunt = 6; V.taunt = []; V.petition = -99; V.pets = 0;
        // 營裡的兵都回營：堅壁不出
        for (const u of m.alive(V.men)) { u.owner = null; u.home = [CAMP[0] - 200 + (SG.rand() - 0.5) * 300, CAMP[1] + (SG.rand() - 0.5) * 300]; }
        m.card('時朝廷以亮僑軍遠寇，利在急戰，每命帝持重，以候其變。', '《晉書·宣帝紀》');
        m.after(3, () => m.line('司馬懿', '回營。亮遠來，糧少，求戰不得，自然生變——我們等。'));
        m.after(7, () => m.line('提示', '這段要撐過百餘日。蜀軍會到營門前挑戰，營中的怒氣會上升；怒氣滿了，諸將就會不顧節度出營決戰。回帥帳「表請決戰」（站 2.5 秒）可以讓怒氣下降。不要出營。'));
        m.mark('tent', TENT[0], TENT[1], '帥帳', true);
        m.obj('wait', '');
        m.obj('anger', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, d = (w.t - V.t0) / DAY;
        m.get('wait').text = V.back ? `對壘百餘日（第 ${Math.floor(d) + 1} 日）・不要出營` : '回營（渭南大營）';
        // 出營：墮亮畫中（先回到營裡才開始算）
        if (inCamp(me)) V.back = true;
        if (V.back && !inCamp(me) && !V.outNow) {
          V.outNow = true; V.sortie = true;
          m.line('姜維', '司馬懿出營了！伏兵，起！');
          for (let i = 0; i < 6; i++) { const u = m.foe('huangjin', me.x - 350 + (i % 3) * 60, me.y + (i < 3 ? -320 : 320), SHU); u.home = [me.x, me.y]; }
          for (let i = 0; i < 4; i++) m.after(i * 0.7, () => m.strike(me.x + (SG.rand() - 0.5) * 120, me.y + (SG.rand() - 0.5) * 80, 110, 1, 90, 0));
        }
        if (inCamp(me)) V.outNow = false;
        // 挑戰：每 12 日一次，到營門前叫陣
        V.nextTaunt -= dt;
        if (V.nextTaunt <= 0 && d < DAYS - 8) {
          V.nextTaunt = 12 * DAY;
          V.taunt = Array.from({ length: 6 }, (_, i) => { const u = m.foe('huangjin', TAUNT[0] - 700, TAUNT[1] - 150 + (i % 3) * 150, SHU); u.home = [TAUNT[0] - (i >> 1) * 60, TAUNT[1] - 150 + (i % 3) * 150]; u.taunt = true; return u; });
          m.line('蜀兵', ['司馬懿！出來一戰！', '魏軍都是縮頭的嗎？', '仲達！敢出營否？'][Math.floor(SG.rand() * 3)]);
          m.after(8 * DAY, () => { for (const u of V.taunt) if (u.alive) { u.home = [RAMP[0], RAMP[1]]; u.taunt = false; } });
        }
        for (const u of V.taunt) if (u.alive && u.taunt) { u.target = null; u.think = 0.5; } // 只叫陣，不攻營
        const loud = V.taunt.filter((u) => u.alive && u.taunt && SG.gd(u.x, u.y, TAUNT[0], TAUNT[1]) < 400).length;
        V.anger = Math.min(ANGER_MAX, V.anger + dt * loud * 0.22 * (V.xinpi ? 0.4 : 1));
        // 巾幗婦人之飾
        if (d > 40 && !V.jinguo) {
          V.jinguo = true;
          V.envoy = m.folk(TAUNT[0] - 600, TAUNT[1], { name: '蜀使', still: true, near: 1, look: 2 });
          m.after(3, () => { m.card('亮數挑戰，帝不出，因遺帝巾幗婦人之飾。', '《晉書·宣帝紀》'); V.anger = Math.min(ANGER_MAX, V.anger + 30); m.line('魏將', '欺人太甚！請出戰！'); });
        }
        if (V.envoy && !V.envoyGone && V.jinguo && walkTo(V.envoy, GATE[0] - 60, GATE[1], 120, dt)) { V.envoyGone = true; m.after(4, () => { m.folks = m.folks.filter((f) => f !== V.envoy); }); }
        // 亮使至：問寢食
        if (d > 60 && !V.messenger) {
          V.messenger = m.folk(CAMP[0] - 160, CAMP[1] + 160, { name: '亮使', still: true, near: 160, look: 1,
            lines: [['司馬懿', '諸葛公起居何如，食可幾米？'], ['亮使', '三四升。'], ['司馬懿', '政事呢？'], ['亮使', '二十罰已上皆自省覽。'], ['司馬懿', '（送走使者）諸葛孔明其能久乎！']],
            onHeard: () => { V.asked = true; m.unmark('msg'); } });
          m.mark('msg', CAMP[0] - 160, CAMP[1] + 160, '亮使', true);
          m.line('提示', '諸葛亮的使者到了，去見他。');
        }
        // 表請決戰：示武于其眾
        if (w.t - V.petition > 12) m.chanAt(me, 'pet', TENT[0], TENT[1], 160, 2.5, '表請決戰', () => {
          V.petition = w.t; V.pets++; V.anger = Math.max(0, V.anger - 45);
          m.line('司馬懿', '亮欺我太甚！表請決戰！');
          m.after(2.5, () => m.line('魏將', '……天子不許。'));
          if (V.jinguo && !V.xinpi) m.after(5, () => {
            V.xinpi = m.folk(GATE[0] + 40, GATE[1] - 60, { name: '辛毗', still: true, near: 1, draw: (ctx, f, T) => flag(ctx, f, T), text: '節', col: '#8a2a2a' });
            m.card('乃遣骨鯁臣衞尉辛毗杖節為軍師以制之。後亮復來挑戰，帝將出兵以應之，毗杖節立軍門，帝乃止。', '《晉書·宣帝紀》');
            m.after(4, () => m.line('姜維', '辛毗杖節而至，賊不復出矣。'));
            m.after(8, () => m.line('諸葛亮', '彼本無戰心，所以固請者，以示武于其眾耳。將在軍，君命有所不受，苟能制吾，豈千里而請戰邪！'));
          });
        });
        m.get('anger').text = `營中怒氣 ${Math.floor(V.anger)}%${V.xinpi ? '（辛毗杖節立軍門）' : ''}`;
        if (V.anger >= ANGER_MAX) { m.lose('諸將不顧節度出營決戰，墮亮畫中'); return false; }
        return d >= DAYS;
      },
    },
    { // 3. 亮卒：追擊，窮寇勿逼
      enter(m, w) {
        const V = m.vars;
        m.drop('anger'); m.done('wait'); m.unmark('tent'); m.unmark('msg');
        rout(m, w, w.units.filter((u) => u.team === 1 && u.alive), VALLEY);
        m.card('有星赤而芒角，自東北西南流，投于亮營，三投再還，往大還小。俄而亮卒。', '《晉陽秋》（裴注《諸葛亮傳》）');
        for (let i = 0; i < 8; i++) m.fire(YUAN[0] - 400 + (i % 4) * 260, YUAN[1] - 200 + Math.floor(i / 4) * 300, { dps: 40, life: 25 });
        m.after(4, () => {
          m.folk(CAMP[0] - 500, CAMP[1] + 80, { name: '百姓', still: true, near: 400, lines: [['百姓', '蜀軍燒營走了！五丈原上全是煙！']] });
          m.line('司馬懿', '諸葛亮死了？……出兵，追！');
          V.rear = Array.from({ length: 10 }, (_, i) => { const u = m.foe('huangjin', RAMP[0] - 500 - (i % 5) * 70, RAMP[1] - 100 + Math.floor(i / 5) * 160, Object.assign({}, SHU, { name: i ? '蜀兵' : '楊儀' })); u.home = [u.x, u.y]; u.rear = true; return u; });
          V.yi = V.rear[0];
          m.mark('rear', V.yi.x, V.yi.y, '蜀軍殿後', false, V.yi);
          m.obj('chase', '追擊蜀軍');
        });
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        if (!V.rear) return false;
        const live = m.alive(V.rear), near = live.length ? Math.min(...live.map((u) => SG.gd(u.x, u.y, me.x, me.y))) : 1e9;
        for (const u of live) if (!V.faced || V.faced && !V.gone) { u.target = V.faced && near < 380 ? me : null; u.think = 0.4; }
        if (!V.faced && near < 900) {
          V.faced = w.t;
          m.big('楊儀反旗鳴鼓！');
          m.card('楊儀等整軍而出，百姓奔告宣王，宣王追焉。姜維令儀反旗鳴鼓，若將向宣王者，宣王乃退，不敢偪。', '《漢晉春秋》（裴注《諸葛亮傳》）');
          m.obj('halt', '窮寇勿逼：不要靠近');
        }
        if (V.faced && !V.gone) {
          if (near < 520 && !V.pressed) { V.pressed = true; m.line('姜維', '魏軍逼上來了——射！'); for (let i = 0; i < 5; i++) m.after(i * 0.5, () => m.strike(me.x + (SG.rand() - 0.5) * 140, me.y + (SG.rand() - 0.5) * 100, 110, 0.9, 120, 0)); }
          if (w.t - V.faced > 12) {
            V.gone = true;
            m.done('halt'); m.done('chase'); m.unmark('rear');
            m.card('帝以窮寇不之逼，於是楊儀結陣而去。', '《晉書·宣帝紀》');
            for (const u of live) { u.untargetable = true; u.home = VALLEY.slice(); u.target = null; u.ms = 280; }
            m.after(8, () => { for (const u of V.rear) if (u.alive) vanish(w, u); });
            return true;
          }
        }
        return false;
      },
    },
    { // 4. 行其營壘
      enter(m, w) {
        const V = m.vars;
        m.after(4, () => {
          m.line('司馬懿', '經日了。去看看他的營壘。');
          V.seen = SPOILS.map(() => false);
          SPOILS.forEach(([x, y, k], i) => m.mark('s' + i, x, y, k, true));
          m.obj('look', '行其營壘，觀其遺事', 3);
        });
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!V.seen) return false;
        SPOILS.forEach(([x, y, k], i) => { if (!V.seen[i] && m.near(me, x, y, 200)) { V.seen[i] = true; m.unmark('s' + i); m.line('司馬懿', { 營壘: '營壘井竈，皆有法度……', 圖書: '軍書密計都丟下了。', 糧穀: '糧穀還這麼多。' }[k]); } });
        m.prog('look', V.seen.filter(Boolean).length);
        if (!V.seen.every(Boolean)) return false;
        m.card('乃行其營壘，觀其遺事，獲其圖書、糧穀甚眾。帝審其必死，曰：「天下奇才也。」', '《晉書·宣帝紀》');
        m.after(5, () => m.card('百姓為之諺曰：「死諸葛走生仲達。」或以告宣王，宣王曰：「吾能料生，不便料死也。」', '《漢晉春秋》（裴注《諸葛亮傳》）'));
        m.after(10, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('司馬懿陣亡'); return; }
    const gh = m.vars.gh;
    if (gh) { allyTick(w, gh, w.player, 420); if (gh.hp < gh.maxHp * 0.3) gh.hp = gh.maxHp * 0.3; } // 郭淮這一戰沒死
  },
};
